/**
 * @file   src\mobile\components\WantAdListing\PublishedWantAds.js
 * @brief  This file is responsible for showing published want ads listing
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import WantAdFeatures from "./v2/WantAdFeatures";

const PublishedWantAds = () => {
  return <WantAdFeatures />;
};

export default PublishedWantAds;
